import { Icon } from './chunk-VH4ICUUK.js';
import { tv } from './chunk-7NOFBOMW.js';
import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var alertVariants = tv({
  base: "relative w-full rounded-lg border px-4 py-4 text-base [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  variants: {
    variant: {
      default: "bg-background text-foreground",
      destructive: "bg-background border-destructive text-destructive [&>svg]:text-destructive",
      success: "bg-background border-success text-success [&>svg]:text-success"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
var iconsToVariantMap = {
  default: "info",
  destructive: "info",
  success: "circle-check"
};
var Alert = forwardRef(
  ({ className, children, variant = "default", ...props }, ref) => {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: alertVariants({
          className,
          variant
        }),
        ref,
        ...props,
        children: [
          /* @__PURE__ */ jsx(Icon, { name: iconsToVariantMap[variant], className: "w-4 h-4" }),
          children
        ]
      }
    );
  }
);
Alert.displayName = "Alert";
var alertTitleStyles = tv({
  base: "mb-1 font-medium leading-none"
});
var AlertTitle = forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ jsx("h5", { ref, className: alertTitleStyles({ className }), ...props })
);
AlertTitle.displayName = "AlertTitle";
var alertDescriptionStyles = tv({
  base: "text-sm [&_p]:leading-relaxed"
});
var AlertDescription = forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: alertDescriptionStyles({ className }), ...props })
);
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertDescription, AlertTitle, alertDescriptionStyles, alertTitleStyles, alertVariants };
//# sourceMappingURL=chunk-IHPYB3PJ.js.map
//# sourceMappingURL=chunk-IHPYB3PJ.js.map